export default __webpack_public_path__ + "static/media/tem_sectiont.b2f33162.png";